<template>
  <div>
    <b-modal
      v-model="modalValue"
      size="xl"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="card card-custom card-stretch">
        <!--begin::Header-->
        <div class="card-header border-0 align-items-center">
          <h3 class="card-title align-items-start flex-column">
          <span class="title font-weight-bold">
            {{i18n.sectionSelect}}
          </span>
          </h3>
          <div class="card-toolbar toolbar-symbol">
            <b-button variant="dark" class="btn-icon rounded-lg" size="sm" @click="modalValue = false">
              <i class="la la-close font-size-h5"></i>
            </b-button>
          </div>
        </div>
        <!--end::Header-->
        <!-- begin::Body -->
        <div class="card-body pt-5">
          <div class="form-group row mb-4" style="display: block;">
            <label class="col-sm-2 col-form-label">
              <span class="h5">{{i18n.section}}</span>
            </label>
            <div class="col-sm-4" style="max-width:100%">
              <v-data-table
                :headers="rackGroupColumn"
                :items="rackGroupList.rackGroupList"
                item-key="rackGroupNo"
                class="elevation-1 farm-data-table"
                :no-data-text="`${i18n.noData}`"
                hide-default-footer
                single-expand
                @click:row="rackGroupClick"
                style="cursor: pointer;"
                :items-per-page="-1"
              >
              <!-- 바디 -->
              </v-data-table>
              <!--begin::pagination-->
              <div class="pagination mt-12">
                <b-pagination
                  :total-rows="rackGroupPaging.totalCount"
                  v-model="rackGroupPaging.pageNo"
                  :per-page = "rackGroupPaging.pageSize"
                  limit="10"
                >
                  <template #first-text><i class="fas fa-angle-double-left"></i></template>
                  <template #prev-text><i class="fas fa-angle-left"></i></template>
                  <template #next-text><i class="fas fa-angle-right"></i></template>
                  <template #last-text><i class="fas fa-angle-double-right"></i></template>
                  <template #page="{ page, active }">
                    <span v-if="active" class="font-size-sm font-weight-bold text-white">{{ page }}</span>
                    <span v-else class="font-size-sm font-weight-bold text-dark">{{ page }}</span>
                  </template>
                </b-pagination>
              </div>
            <!--end::pagination-->
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  
  import i18n from '@/core/plugins/vue-i18n.js';
  import {
    ACT_GET_YIELD_RACK_GROUP,
  } from '@/core/services/variable';
  import {RackGroup, RackGroupList} from '@/view/model/RackModel.js'
  import {Paging} from '@/view/model/PagingModel.js'

  export default {
    props: {
      sectionSelectModal: Boolean,
      farmInfo: Object,
    },
    computed: {
      modalValue: {
        get() {
          return this.sectionSelectModal;
        },
        set(value) {
          this.$emit("sectionSelectModalUpdate", value);
        },
      },
    },
    data() {
      return {
        i18n: {
          sectionSelect: i18n.t('farm.yield.sectionSelect'), // 구역 선택
          section: i18n.t('farm.yield.section'), // 구역
          noData: i18n.t('farm.yield.noData'),
        },
        rackGroupColumn: [
            { value: 'rackGroupName', text: i18n.t('farm.yield.sectionName'), width: '80px' },
            { value: 'rackLocation', text: i18n.t('farm.yield.section'), width: '150px' },
            { value: 'plantingTotalCapa', text: i18n.t('farm.yield.plantingTotalCapa'), width: '30px' },
          ],
        rackGroupPaging : new Paging(),
        rackGroupList : new RackGroupList(),

      }
    },
    created() {
      
    },
    watch : {
      sectionSelectModal(value){
        if(value){
          this.init()
        }
      },
      "rackGroupPaging.pageNo"(newPage) {
        this.getRackGroup()
      }
    }, 
    methods: {
      // 초기화
      init(){
        this.getRackGroup()
      },
      // 랙 그룹 조회
      getRackGroup(){
        const params = {
          fno: this.farmInfo.fno,
          pageNo : this.rackGroupPaging.pageNo,
          pageSize: this.rackGroupPaging.pageSize
        }
        this.$store.dispatch(ACT_GET_YIELD_RACK_GROUP, params).then(resp => {
          this.rackGroupPaging.totalCount = resp.paging.totalCount
          // 랙의 모든 데이터
          this.rackGroupList.rackGroupList = []
          resp.items.map(data => this.rackGroupList.addRackGroup(RackGroup.objectRackGroup(data)));
        })
      },
      // 랙 구역 선택 로우 클릭
      rackGroupClick(item) {
        this.$emit("farmRackNameList", item)
        this.modalValue = false
      },
    }
  }
</script>
